<template>
    <div>
        <v-dialog v-model="visible" transition="dialog-top-transition" scrollable persistent max-width="700">
            <v-card class="modal-maincard">

                <v-toolbar dark flat dense>
                    <v-toolbar-title>{{ $t(this.title) }}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal">
                    <v-card
                        v-if="url"
                        flat
                    >
                        <v-card-text>
                            <v-img
                                contain
                                :src="url"
                                lazy-src="@/assets/placeholder-png-image.png"
                                transition="scale-transition"
                            >
                                <template v-slot:placeholder>
                                    <v-row
                                        class="fill-height ma-0"
                                        align="end"
                                        justify="center"
                                    >
                                        <v-progress-linear
                                            color="#a94442"
                                            indeterminate
                                            rounded
                                            height="6"
                                        ></v-progress-linear>
                                    </v-row>
                                </template>
                            </v-img>
                        </v-card-text>
                    </v-card>  
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn 
                        color="cyan" 
                        text
                        depressed
                        @click="onSavePicture"
                    >
                        {{$t("Загрузить")}}
                    </v-btn>

                    <v-btn 
                        color="blue-grey" 
                        text
                        depressed 
                        @click="cancel"
                    >
                        {{$t("Отмена")}}
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "CommentPicturePreview",
    data () {
        return {
            title: "Превью_изображения",
            visible: false,
            url: null,
            item: null
        }
    },
    methods: {
        async open(url, item)
        {
            this.url = url;
            this.item = item;
            this.visible = true;
        },
        cancel() {
            this.visible = false;
            this.url = null;
            this.item = null;
        },
        async onSavePicture() {
            this.$eventBus.$emit('on-download-file', { id: this.item.Id, name: this.item.Name });
        }
    }
}
</script>